import React, { useState, useContext } from "react";
import { useQuery } from "@tanstack/react-query";
import DataTable from "./../../../Layout/Table/TableLayout";
import Navbar from "../../../Shared/Sales-ExecutiveNavbar/Navbar";
import { FaEye, FaEdit, FaTrash } from "react-icons/fa";
import "./MyTeamSales.css";
import { AuthContext } from "../../../../Components/AuthContext/AuthContext";
import axios from "axios";
import { baseURL } from "../../../Apiservices/Api";

const MyTeamSales = () => {
  const { userId } = useContext(AuthContext);
  const [collapsed, setCollapsed] = useState(false);

  const { data: managerData, isLoading, isError } = useQuery({
    queryKey: ["myTeamSales", userId],
    refetchInterval: 3000, // Refetch every 3 seconds to keep data updated
    queryFn: async () => {
      const response = await axios.get(`${baseURL}/${userId}`);
      return response.data;
    },
    enabled: !!userId,
  });

  const columns = React.useMemo(
    () => [
      {
        Header: "S.no",
        accessor: (_row, index) => index + 1,
      },
      {
        Header: "Name",
        accessor: "name",
      },
      {
        Header: "Mobile",
        accessor: "mobile",
      },
      {
        Header: "Email",
        accessor: "email",
      },
      {
        Header: "Designation",
        accessor: "designation",
      },
    ],
    []
  );

  if (isLoading) return <div>Loading data...</div>;
  if (isError) return <div>Failed to fetch data.</div>;

  const data =
    managerData && managerData.manager
      ? [
          {
            employeeId: managerData.manager?.id || "N/A",
            name: managerData.manager?.name || "N/A",
            mobile: managerData.manager?.mobile || "N/A",
            email: managerData.manager?.email || "N/A",
            designation: "Manager - Sales & Operations",
          },
          ...(managerData.assignedEmployees
            ? managerData.assignedEmployees.map((emp) => ({
                employeeId: emp?.id || "N/A",
                name: emp?.name || "N/A",
                mobile: emp?.mobile || "N/A",
                email: emp?.email || "N/A",
                designation: "Associate - Sales & Operations",
              }))
            : []),
        ]
      : [];

  return (
    <div className="salesmyteamcontainer">
      <Navbar onToggleSidebar={setCollapsed} />
      <div className={`salesmyteam ${collapsed ? "collapsed" : ""}`}>
        <div className="Sales-myteam-container mb-5">
          <div className="Sales-myteam-table-container">
            <h3 className="d-flex justify-content-between align-items-center"></h3>
            <DataTable columns={columns} data={data} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default MyTeamSales;